import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { PageNames } from 'src/app/configs/page-names.enum';

import { ExcelTypes } from 'src/app/core/api/models';
import { ResellerOutBoxMessagesWithPaginationDto } from 'src/app/core/api/models/reseller-out-box-messages-with-pagination-dto';
import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';

@Component({
  selector: 'app-reseller-outbox-messages',
  templateUrl: './reseller-outbox-messages.component.html',
  standalone: false,
})
export class ResellerOutboxMessagesComponent extends BasePageComponent {
  //#region Properties

  modelWithPagination$: Observable<any>;
  items$: Observable<Array<ResellerOutBoxMessagesWithPaginationDto>>;
  getTableDataApiMethodName: string =
    'outBoxMessagesGetResellerOutBoxMessageWithPagination';
  getTotalCountApiMethodName: string =
    'outBoxMessagesGetResellerOutBoxMessagesTotalReceiversCountTotalPrices';
  pageTitle: string = 'pages.outboxMessages.resellerTitle';
  excelType = ExcelTypes.ResellerOutboxMessages;
  tabName = PageNames.resellerOutboxMessages;

  //#endregion
}
